import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import { useState } from "react";

type MarkerData = {
  position: { lat: number; lng: number };
  count: number;
};

const TrackingMap = ({
  groupedTrucks,
}: {
  groupedTrucks: Record<string, any[]>;
}) => {
  console.log(groupedTrucks);
  //   const center = { lat: 34.0522, lng: -118.2437 }; // Default center
  const center = { lat: 39.8282, lng: -98.5796 };
  const [selectedMarker, setSelectedMarker] = useState<MarkerData | null>(null);

  return (
    <GoogleMap
      mapContainerStyle={{ height: "100%", width: "100%" }}
      center={center}
      zoom={4.5}
    >
      {Object.entries(groupedTrucks).map(([key, trucks]) => {
        const [lat, lng] = key.split(",").map(Number);
        const count = trucks.length;
        return (
          <Marker
            key={key}
            position={{ lat, lng }}
            label={{ text: String(count), color: "white", fontSize: "12px" }}
            icon={{
              path: google.maps.SymbolPath.CIRCLE,
              scale: 10,
              fillColor: "red",
              fillOpacity: 0.9,
              strokeWeight: 1,
            }}
          />
        );
      })}
      {selectedMarker && (
        <InfoWindow
          position={selectedMarker.position}
          onCloseClick={() => setSelectedMarker(null)}
        >
          <div>Trucks at this location: {selectedMarker.count}</div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};
export default TrackingMap;
